import React, { useState, useEffect } from 'react';
import { Globe } from 'lucide-react';

const LANGUAGES = {
  en: { name: 'English', flag: '🇬🇧' },
  ru: { name: 'Русский', flag: '🇷🇺' },
  zh: { name: '中文', flag: '🇨🇳' },
  ar: { name: 'العربية', flag: '🇸🇦' }
};

const LanguageSelector = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [isOpen, setIsOpen] = useState(false);
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    // Load translations from localStorage if exists
    const savedLang = localStorage.getItem('maisonEzeLanguage');
    if (savedLang && LANGUAGES[savedLang]) {
      setCurrentLanguage(savedLang);
      document.documentElement.lang = savedLang;
    }
  }, []);

  const handleLanguageChange = async (langCode) => {
    setCurrentLanguage(langCode);
    localStorage.setItem('maisonEzeLanguage', langCode);
    document.documentElement.lang = langCode;
    setIsOpen(false);
    
    // Dispatch custom event to update translations
    window.dispatchEvent(new Event('languageChange'));
  };

  return (
    <div className="language-selector" style={{ position: 'relative' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="language-button"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 12px',
          background: 'transparent',
          border: '1px solid rgba(51,51,51,0.2)',
          borderRadius: '0px',
          cursor: 'pointer',
          fontSize: '14px',
          fontFamily: 'Inter, sans-serif',
          color: '#333333',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = '#333333';
          e.currentTarget.style.background = 'rgba(51,51,51,0.05)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = 'rgba(51,51,51,0.2)';
          e.currentTarget.style.background = 'transparent';
        }}
      >
        <Globe className="w-4 h-4" />
        <span>{LANGUAGES[currentLanguage].flag}</span>
        <span>{LANGUAGES[currentLanguage].name}</span>
      </button>

      {isOpen && (
        <div
          className="language-dropdown"
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: '8px',
            background: '#fffef2',
            border: '1px solid rgba(51,51,51,0.2)',
            borderRadius: '0px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            zIndex: 1000,
            minWidth: '180px'
          }}
        >
          {Object.entries(LANGUAGES).map(([code, lang]) => (
            <button
              key={code}
              onClick={() => handleLanguageChange(code)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                width: '100%',
                padding: '12px 16px',
                background: currentLanguage === code ? 'rgba(201,169,97,0.1)' : 'transparent',
                border: 'none',
                borderBottom: '1px solid rgba(51,51,51,0.1)',
                cursor: 'pointer',
                fontSize: '14px',
                fontFamily: 'Inter, sans-serif',
                color: '#333333',
                textAlign: 'left',
                transition: 'background 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(201,169,97,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = currentLanguage === code ? 'rgba(201,169,97,0.1)' : 'transparent';
              }}
            >
              <span style={{ fontSize: '20px' }}>{lang.flag}</span>
              <span>{lang.name}</span>
              {currentLanguage === code && (
                <span style={{ marginLeft: 'auto', color: '#C9A961' }}>✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;